import { FunctionComponent } from 'react';
import SeelLogoHorizontal from 'components/common/logos/SeelLogoHorizontal';

import styles from './HowToUseRA.module.sass';
import TitleSection from './HowToUseRA/TitleSection';
import ScreenshotIntro from './HowToUseRA/ScreenshotIntro';
import Procedures from './HowToUseRA/Procedures';
// import ReturnPolicy from './HowToUseRA/ReturnPolicy';
// import ReturnProcess from './HowToUseRA/ReturnProcess';
import { AboutPageConfigs, NewAboutPageConfigs } from '../../services/partnerUser.service';
// import TermsOfService from './HowToUseRA/TermsOfService';
import HowToReturn from './HowToUseRA/HowToReturn';
import Separator from './common/Separator';

export enum ReturnMethod {
    Label,
    Merchant,
}

const HowToUseRA: FunctionComponent<NewAboutPageConfigs> = ({
    returnToSeel,
    shopDomain,
    returnWindow,
}) => {
    const isHolyThrift = shopDomain === 'holythrift.com';
    return (
        <div className={styles.container}>
            {isHolyThrift ? (
                <>
                    <div className={styles.logo}>
                        <SeelLogoHorizontal />
                    </div>
                    <HowToReturn {...{ returnToSeel, shopDomain, returnWindow }} />
                    <div className={styles.subTitle}>
                        Adding Seel Return Assurance allows you to return eligible items for a
                        refund.
                    </div>
                    <Separator />
                </>
            ) : (
                <TitleSection />
            )}

            <ScreenshotIntro />
            <Procedures />
            {!isHolyThrift && <HowToReturn {...{ returnToSeel, shopDomain, returnWindow }} />}
            {/* <ReturnPolicy name={name} policy={policy} /> */}
            {/* <ReturnProcess type={returnMethod} link={link} name={name} />
            <TermsOfService /> */}
        </div>
    );
};
export default HowToUseRA;
